import React, { Component } from 'react';

import Spinner from '../../svg/spinner';

import css from './submit.scss';

export default class InputSubmit extends Component {
	static propTypes = {
		name: React.PropTypes.string.isRequired,
		waiting: React.PropTypes.bool,
		onClick: React.PropTypes.func,
	};

	static defaultProps = {
		waiting: false,
		onClick: () => {},
	};

	render() {
		let defaultClass = 'form-submit';
		let spinnerClass = 'form-submit__spinner';

		if (this.props.className) {
			defaultClass += ' ' + this.props.className;
		}

		if (this.props.waiting) {
			defaultClass += ' form-submit--show-spinner';
		}

		return (
			<button type='submit' value={this.props.name} {...this.props} className={defaultClass} onClick={this.props.onClick}>
				{this.props.name}

				<Spinner size='16px' className={spinnerClass} pathbgStroke='transparent' pathStroke='#dbdbdb' active={this.props.waiting} />
			</button>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/input/submit.js
 **/